import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../Header'
import LicenseBanner from "../LicenseBanner"
import { useDoorData } from '../context/DoorContext'

function RootLayout() {
  const [license, setLicense] = useState(null)
  const { axiosJWT } = useDoorData()

  useEffect(() => {
    axiosJWT.get("/api/license/status")
      .then(res => setLicense(res.data))
      .catch(() => {})
  }, [axiosJWT])

  return (
    <Box minH="100vh" bg="gray.50">
      <Header license={license} />
      <LicenseBanner status={license} />
      <Box px={4} py={6}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default RootLayout
